import type { components } from "@/api-schema";
import { BrandIdentifierSystem } from "@/api-schema-enums";
import { normalizePositiveSafeIntegerIdentifier } from "@/common/helpers/normalize-numeric-identifier";

type Brand = Pick<components["schemas"]["Brand"], "brandIdentifiers">;
type BrandIdentifierDto = components["schemas"]["BrandIdentifierDto"];

function getBrandIdentifier(brand: Brand, type: BrandIdentifierSystem): string | undefined {
  return brand.brandIdentifiers?.find((identifier) => identifier.type === type)?.identifier;
}

export function getBrandV1Identifier(brand: Brand): string | undefined {
  return getBrandIdentifier(brand, BrandIdentifierSystem.V1);
}

export function getBrandDatIdentifier(brand: Brand): string | undefined {
  return getBrandIdentifier(brand, BrandIdentifierSystem.Dat);
}

export function toBrandIdentifierDtos({
  v1Identifier,
  datIdentifier,
}: {
  v1Identifier: string;
  datIdentifier: string;
}): BrandIdentifierDto[] {
  const normalizedV1Identifier = normalizePositiveSafeIntegerIdentifier(v1Identifier);
  const normalizedDatIdentifier = datIdentifier.trim();

  return [
    ...(normalizedV1Identifier === undefined
      ? []
      : [{ type: BrandIdentifierSystem.V1, identifier: normalizedV1Identifier }]),
    ...(normalizedDatIdentifier ? [{ type: BrandIdentifierSystem.Dat, identifier: normalizedDatIdentifier }] : []),
  ];
}
